module.exports = [{"name":"PRIME_PRIMO265","version":1},{"name":"FSC_SUMO5041","version":1}]